import {
    inboxWorkflowColumn,
    inboxWorkflowPartialMessage,
    type InboxWorkflowCellComponent,
    type InboxWorkflowJson,
    type InboxWorkflowTableStepConfig,
} from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
import SourceCleanupCompletionCell from "../../../../_shared/_modules/source-cleanup-completion-cell"
import SourceCleanupPreconfiguration from "../../../../_shared/_modules/source-cleanup-preconfiguration"
import CustomerSourceCleanupCustomerCell from "./_modules/customer-source-cleanup-customer-cell"
import CustomerSourceCleanupInstructionsCell from "./_modules/customer-source-cleanup-instructions-cell"
import CustomerSourceCleanupPropertyCell from "./_modules/customer-source-cleanup-property-cell"
import CustomerSourceCleanupSourceCell from "./_modules/customer-source-cleanup-source-cell"
import type { CustomerSourceCleanupDraft, CustomerSourceCleanupRow } from "./contract"
import { buildCustomerSourceCleanupRows } from "./_logic/tableRows"

export const sourceCleanupCells: Record<string, InboxWorkflowCellComponent> = {
  verificationSourceCleanupCompletion: SourceCleanupCompletionCell,
  verificationSourceCleanupCustomer: CustomerSourceCleanupCustomerCell,
  verificationSourceCleanupInstructions: CustomerSourceCleanupInstructionsCell,
  verificationSourceCleanupProperty: CustomerSourceCleanupPropertyCell,
  verificationSourceCleanupSource: CustomerSourceCleanupSourceCell,
}

export const createSourceCleanupStep = (): InboxWorkflowTableStepConfig<
  CustomerSourceCleanupRow,
  CustomerSourceCleanupDraft,
  InboxWorkflowJson
> => ({
  kind: "table",
  columns: [
    inboxWorkflowColumn(
      "sourceInstructions",
      "Im Kehrbezirksprogramm erledigen",
      "verificationSourceCleanupInstructions",
    ),
    inboxWorkflowColumn(
      "completion",
      "Im Kehrbezirksprogramm nachgetragen?",
      "verificationSourceCleanupCompletion",
    ),
    inboxWorkflowColumn("sourceLabel", "Herkunft", "verificationSourceCleanupSource"),
    inboxWorkflowColumn("addressLabel", "Liegenschaft", "verificationSourceCleanupProperty"),
    inboxWorkflowColumn("customerLabel", "Ansprechpartner", "verificationSourceCleanupCustomer", {
      isPrimary: true,
    }),
  ],
  buildRows: ({ workflow, step, rowOutcomes }) =>
    buildCustomerSourceCleanupRows({ workflow, step, rowOutcomes }),
  draft: {
    create: (row) => ({ completed: row.completed }),
    validate: (_row, draft) =>
      draft.completed
        ? null
        : "Bitte markieren Sie jede offene Zeile als im Kehrbezirksprogramm erledigt.",
  },
  preconfiguration: SourceCleanupPreconfiguration,
  buildPayload: () => ({}),
  commit: {
    label: "Nachtrag erledigt markieren",
    successMessage: "Nachtrag wurde als erledigt markiert.",
    partialMessage: inboxWorkflowPartialMessage,
  },
})
